const STORAGE_KEY = 'kfv-theme'
const isDarkMode = ref(false)

export default function useDarkMode() {
  function applyTheme(dark: boolean) {
    if (typeof document === 'undefined') return
    document.documentElement.classList.toggle('dark-theme', dark)
  }

  function initDarkMode() {
    if (typeof window === 'undefined') return
    const saved = localStorage.getItem(STORAGE_KEY)
    const dark = saved
      ? saved === 'dark'
      : window.matchMedia('(prefers-color-scheme: dark)').matches
    isDarkMode.value = dark
    applyTheme(dark)
  }

  function toggleDarkMode() {
    isDarkMode.value = !isDarkMode.value
    localStorage.setItem(STORAGE_KEY, isDarkMode.value ? 'dark' : 'light')
    applyTheme(isDarkMode.value)
  }

  return { isDarkMode, initDarkMode, toggleDarkMode }
}
